// TODO get a better list
// API will also need update to support expanded list
enum Genders {
  MALE = 'Male',
  FEMALE = 'Female',
}

export default Genders;
